import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { processesRepo } from '@/constants/providers';
import { DataWithPagination } from '@/shared/types';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { ProcessItem } from '../domain';
import { ProcessKey } from './keys';

export const useGetProcesses = (
  pageNumber?: number,
  filter?: string,
  sortBy?: string,
  sortOrder?: SortDirection,
  options?: UseQueryOptions<DataWithPagination<ProcessItem[]>>,
) => {
  const { currentSelectedTenant } = useContext(TenantContext);

  return useQuery<DataWithPagination<ProcessItem[]>>(
    [
      ...ProcessKey.LIST_PAGED({ pageNumber, filter, sortBy, sortOrder }),
      currentSelectedTenant?.id,
    ],
    () => processesRepo.getAllProcesses(pageNumber, filter, sortBy, sortOrder),
    { ...options, cacheTime: 1000 * 60 * 5 },
  );
};
